import { all, call, takeEvery, fork } from "redux-saga/effects";
import requestFunction from "../Utils/sagasGenericFunction";

import {
  FETCH_TODAY_AUDIT_TRAIL,
  FETCH_ALL_AUDIT_TRAIL,
  FETCH_AUDIT_TRAIL_ACTIONS,
} from "../ActionTypes";

import { getTodaysAuditTrail, getAllAuditTrail, getAuditTrailActions } from "../Api";

import {
  fetchTodaysAuditTrailSuccess,
  fetchAllAuditTrailSuccess,
  fetchAuditTrailActionsSuccess,
} from "../Actions";

export const fetchTodayAuditRequest = function* ({ payload }) {
  yield call(requestFunction, fetchTodaysAuditTrailSuccess, getTodaysAuditTrail, payload);
};

export const fetchTodayAudit = function* () {
  yield takeEvery(FETCH_TODAY_AUDIT_TRAIL, fetchTodayAuditRequest);
};

export const fetchAllAuditRequest = function* ({ payload }) {
  yield call(requestFunction, fetchAllAuditTrailSuccess, getAllAuditTrail, payload);
};

export const fetchAllAudit = function* () {
  yield takeEvery(FETCH_ALL_AUDIT_TRAIL, fetchAllAuditRequest);
};

export const fetchAuditActionsRequest = function* ({ payload }) {
  yield call(requestFunction, fetchAuditTrailActionsSuccess, getAuditTrailActions, payload);
};

export const fetchAuditAction = function* () {
  yield takeEvery(FETCH_AUDIT_TRAIL_ACTIONS, fetchAuditActionsRequest);
};

export default function* rootSaga() {
  yield all([fork(fetchTodayAudit), fork(fetchAllAudit), fork(fetchAuditAction)]);
}
